export type Props = {
  blobFromFetch: Blob;
  extension: "pdf" | "xlsx";
  fileName: string;
};

export function downloadFile({
  blobFromFetch,
  extension,
  fileName,
}: Props): void {
  const blob = blobFromFetch;
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${fileName}.${extension}`);
  document.body.appendChild(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(url); // cleanup
}
